import { getTvObject } from '@costar-ui/cosmos';

var tvObject = getTvObject({
  base: '',
  variants: {
    orientation: {
      horizontal: ['[&>*:not(:first-child)]:border-l-0', '[&>*:first-child]:rounded-l-lg [&>*:last-child]:rounded-r-lg'],
      vertical: ['[&>*:not(:first-child)]:border-t-0', '[&>*:first-child]:rounded-t-lg [&>*:last-child]:rounded-b-lg']
    },
    enableBorder: {
      "true": ['']
    }
  }
});
var nextToggleButtonGroup = tvObject;

export { nextToggleButtonGroup as default };
//# sourceMappingURL=next-toggle-button-group.esm.js.map
